import { render } from "./AccountNavigation.vue?vue&type=template&id=e0effff4"
import script from "./AccountNavigation.vue?vue&type=script&lang=js"
export * from "./AccountNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__